import Apps from "../../layouts/Apps";
import Carousel from "../../components/apps/Carousel";
import Screenshot2 from "../../assets/img/apps/cogio/screenshot2.png";
import Screenshot3 from "../../assets/img/apps/cogio/screenshot3.png";
import Screenshot4 from "../../assets/img/apps/cogio/screenshot4.png";
import Screenshot5 from "../../assets/img/apps/cogio/screenshot5.png";
import Screenshot6 from "../../assets/img/apps/cogio/screenshot6.png";
import Screenshot7 from "../../assets/img/apps/cogio/screenshot7.png";
import IconText from "../../components/IconText";
import {
    faBug,
    faComments, faHeadset, faIdCard,
    faLink, faLock,
    faMoneyBillWave,
    faRocket,
    faUserShield
} from "@fortawesome/free-solid-svg-icons";
import Button from "../../components/Button";
import {faApple, faSquareInstagram, faTwitter} from "@fortawesome/free-brands-svg-icons";
import CogioIcon from "../../assets/img/apps/cogio/cogio.png";
import SocialLink from "../../components/SocialLink";

export default function CogioApp() {
    const images = [
        Screenshot2,
        Screenshot3,
        Screenshot4,
        Screenshot5,
        Screenshot6,
        Screenshot7
    ];

    const iconStyle = {
        width: "64px",
        height: "64px",
        marginRight: "10px",
        verticalAlign: "middle",
    };

    const headerContainerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px",
        marginBottom: "20px",
    };

    const appNameStyle = {
        display: "flex",
        alignItems: "center",
        margin: 0,
    };

    const socialsTextStyle = {
        marginTop: "25px",
    };

    const rightContent = (
        <div>
            <div style={headerContainerStyle}>
                <h1 style={appNameStyle}>
                    <img style={iconStyle} src={CogioIcon} alt={"Cogio"}/>
                    Cogio
                </h1>
                <Button
                    icon={faApple}
                    text={"Get Cogio for macOS"}
                    onClick={() => window.open("https://apps.apple.com/app/cogio-turn-time-into-insight/id6746819750", "_blank")}
                />
            </div>
            <p>Turn time into insight, privately and offline.</p>
            <Carousel images={images}/>
            <ul>
                <li><IconText text={"No setup"} icon={faRocket} bgColor={true}></IconText> Download and start using
                    right away. No sign up required.
                </li>
                <li><IconText text={"Private"} icon={faUserShield} bgColor={true}></IconText> Your data never leaves
                    your Mac. Stored locally with SQLite.
                </li>
                <li><IconText text={"Flat fee"} icon={faMoneyBillWave} bgColor={true}></IconText> One-time purchase. No
                    subscriptions or hidden fees.
                </li>
            </ul>
            <p>Track and analyze your work sessions with powerful analytics, category management, and seamless menu bar
                integration.</p>

            <h1><IconText icon={faLink} text={"Links"}/></h1>

            <div className="d-flex flex-column gap-2">
                {/*<div className="d-flex flex-wrap gap-2">*/}
                {/*    <Button icon={faComments} text={"Feedback"} to={"/apps/cogio/feedback"}/>*/}
                {/*    <Button icon={faBug} text={"Bug Report"} to={"/apps/cogio/bug-report"}/>*/}
                {/*</div>*/}
                <div className="d-flex flex-wrap gap-2">
                    <Button icon={faHeadset} text={"Support"} to={"/apps/cogio/support"}/>
                    <Button icon={faLock} text={"Privacy Policy"} to={"/apps/cogio/privacy-policy"}/>
                    <Button icon={faIdCard} text={"License"} to={"/apps/cogio/license"}/>
                </div>
            </div>

            <p style={socialsTextStyle}>Follow mpospirit.apps on social media:</p>
            <SocialLink icon={faSquareInstagram} text={"Instagram"} linkText={"@mpospirit.apps"}
                        href={"https://www.instagram.com/mpospirit.apps/"}/>
            <br/>
            <SocialLink icon={faTwitter} text={"Twitter"} linkText={"@mpospiritapps\n"}
                        href={"https://twitter.com/mpospiritapps"}/>
        </div>
    )
    return (
        <div className="cogio-app-page">
            <Apps rightContent={rightContent}/>
        </div>
    )
}
